export class OrderReviewCreateRequest {
    rating: number = 0;
    comment: string = "";
}